import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "creationV2__body creationV2__body--details" }
const _hoisted_2 = { class: "creationV2__scroll-wrapper" }
const _hoisted_3 = { class: "creationV2__container" }
const _hoisted_4 = { class: "flex flex-col gap-2 lg:gap-[calc(8px+0.2vw)]" }
const _hoisted_5 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-start items-center"
}
const _hoisted_7 = { class: "absolute inset-x-0 bottom-12 flex justify-center w-full p-4 lg:p-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center justify-center w-20 h-20 xs:w-24 xs:h-24" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-12 h-12 text-creation-on-background relative z-10 animate-spin",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("linearGradient", { id: "spinner-secondHalf" }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0%",
          "stop-opacity": "0",
          "stop-color": "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "100%",
          "stop-opacity": "0.5",
          "stop-color": "currentColor"
        })
      ]),
      /*#__PURE__*/_createElementVNode("linearGradient", { id: "spinner-firstHalf" }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0%",
          "stop-opacity": "1",
          "stop-color": "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "100%",
          "stop-opacity": "0.5",
          "stop-color": "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", { "stroke-width": "5" }, [
      /*#__PURE__*/_createElementVNode("path", {
        stroke: "url(#spinner-secondHalf)",
        d: "M 8 24 A 16 16 0 0 1 40 24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        stroke: "url(#spinner-firstHalf)",
        d: "M 40 24 A 16 16 0 0 1 8 24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        d: " M 8 25 A 20 20 0 0 1 8 24"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          appear: "",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.agentMessage), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.isError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "button button--large button--secondary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTryAgainClicked && _ctx.onTryAgainClicked(...args)))
                  }, _toDisplayString(_ctx.$t("survey.tryAgainButtonLabel")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_Transition, {
        appear: "",
        name: "custom-classes",
        "enter-active-class": "animate__fadeInUp",
        "leave-active-class": "animate__fadeOutDown"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}